export enum OrganizationStatus {
  ACTIVE = 1,
  INACTIVE = 3,
  DELETE = 0,
}

export const OrganizationStatusOptions = [
  {
    label: "Active",
    value: OrganizationStatus.ACTIVE,
  },
  {
    label: "Inactive",
    value: OrganizationStatus.INACTIVE,
  },
];

export const OrganizationTheme = {
  GrayNeutral: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F3F4F6",
    200: "#E5E7EB",
    300: "#D2D6DB",
    400: "#9DA4AE",
    500: "#6C737F",
    600: "#4D5761",
    700: "#384250",
    800: "#1F2A37",
    900: "#111927",
    950: "#0D121C",
  },
  GreenLight: {
    25: "#FAFEF5",
    50: "#F3FEE7",
    100: "#E4FBCC",
    200: "#D0F8AB",
    300: "#A6EF67",
    400: "#85E13A",
    500: "#66C61C",
    600: "#4CA30D",
    700: "#397C0E",
    800: "#326212",
    900: "#2B5314",
    950: "#15290A",
  },
  Green: {
    25: "#F6FEF9",
    50: "#EDFCF2",
    100: "#D3F8DF",
    200: "#AAF0C4",
    300: "#73E2A3",
    400: "#3CCB7F",
    500: "#16B364",
    600: "#099250",
    700: "#087443",
    800: "#095C37",
    900: "#084C2E",
    950: "#052E1C",
  },
  Cyan: {
    25: "#F5FEFF",
    50: "#ECFDFF",
    100: "#CFF9FE",
    200: "#A5F0FC",
    300: "#67E3F9",
    400: "#22CCEE",
    500: "#06AED4",
    600: "#088AB2",
    700: "#0E7090",
    800: "#155B75",
    900: "#164C63",
    950: "#0D2D3A",
  },
  Blue: {
    25: "#F5FAFF",
    50: "#EFF8FF",
    100: "#D1E9FF",
    200: "#B2DDFF",
    300: "#84CAFF",
    400: "#53B1FD",
    500: "#2E90FA",
    600: "#1570EF",
    700: "#175CD3",
    800: "#1849A9",
    900: "#194185",
    950: "#102A56",
  },
  BlueDark: {
    25: "#F5F8FF",
    50: "#EFF4FF",
    100: "#D1E0FF",
    200: "#B2CCFF",
    300: "#84ADFF",
    400: "#528BFF",
    500: "#2970FF",
    600: "#155EEF",
    700: "#004EEB",
    800: "#0040C1",
    900: "#00359E",
    950: "#002266",
  },
  Purple: {
    25: "#FAFAFF",
    50: "#F4F3FF",
    100: "#EBE9FE",
    200: "#D9D6FE",
    300: "#BDB4FE",
    400: "#9B8AFB",
    500: "#7A5AF8",
    600: "#6938EF",
    700: "#5925DC",
    800: "#4A1FB8",
    900: "#3E1C96",
    950: "#27115F",
  },
  Fuchsia: {
    25: "#FEFAFF",
    50: "#FDF4FF",
    100: "#FBE8FF",
    200: "#F6D0FE",
    300: "#EEAAFD",
    400: "#E478FA",
    500: "#D444F1",
    600: "#BA24D5",
    700: "#9F1AB1",
    800: "#821890",
    900: "#6F1877",
    950: "#47104C",
  },
  Rose: {
    25: "#FFF5F6",
    50: "#FFF1F3",
    100: "#FFE4E8",
    200: "#FECDD6",
    300: "#FEA3B4",
    400: "#FD6F8E",
    500: "#F63D68",
    600: "#E31B54",
    700: "#C01048",
    800: "#A11043",
    900: "#89123E",
    950: "#510B24",
  },
  Primary: {
    25: "#FEFDF0",
    50: "#FEFBE8",
    100: "#FEF7C3",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B74C27",
    800: "#854A0E",
    900: "#713B12",
    950: "#60391C",
  },
  Custom: {
    25: "#FEFDF0",
    50: "#FEFBE8",
    100: "#FEF7C3",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#000000",
    800: "#854A0E",
    900: "#713B12",
    950: "#60391C",
  },
};

export const OrganizationThemeOptions = Object.keys(OrganizationTheme).map(
  (key) => ({
    label: key.replace(/([A-Z])/g, " $1").trim(),
    value: key,
  })
);

export const OrganizationThemeMapping = Object.keys(OrganizationTheme).reduce(
  (acc, key) => {
    acc[key] = OrganizationTheme?.[key as never]?.[700] || "";
    return acc;
  },
  {} as Record<string, string>
);
